import { reducer } from '../reducers/permissions';
import { permissionsRootSaga } from '../sagas/permissions';
import { saga, store } from '../store';

store.addReducers({ permissions: reducer });
saga.run(permissionsRootSaga);
